module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.11813/img/diamond-tier-icon.svg"